// Typelizer digest e5ecdc85c41fb3424409fd96da757bd6
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /session/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/session/new', {}, options),
    method: 'get',
  }),

  /** DELETE /session */
  destroy: (options?: RouteOptions): RouteDefinition<'delete'> => ({
    url: buildUrl('/session', {}, options),
    method: 'delete',
  }),

  /** POST /session */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/session', {}, options),
    method: 'post',
  }),
}
